import api from './api';

const fetchIntegrationLambdas = async () => {
  try {
    const { data } = await api.get('/integration-lambdas');

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default { fetchIntegrationLambdas };
